import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRicevuteFiscaliModalComponent } from './worker-ricevute-fiscali-modal';

export const WorkerRicevuteFiscaliModalModule: string = ng
    .module('worker-ricevute-fiscali-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRicevuteFiscaliModalComponent', WorkerRicevuteFiscaliModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-ricevute-fiscali-modal/worker-ricevute-fiscali-modal.module.ts